export default "__VITE_ASSET__BGpaoB41__"